import { CButton, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CFormSelect, CFormInput } from '@coreui/react'
import React from 'react'
import { useState, useRef } from 'react'
import CustomAgGrid from './../../components/shared/CustomAgGrid'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import SaveDiagnosisData from '../../services/general/saveDiagnosisData.api'
import DeleteDiagnosis from '../../services/general/deleteDiagnosis.api'
import { Form } from '@formio/react'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import FacilityLoginFn from '../../services/general/modifyFacilityLogin.api'
import ApplicationTypeFn from '../../services/general/modifyApplicationType.api.js'
import Select from 'react-select'

import axios from 'axios'
import { useEffect } from 'react'
import CustomDropdown from './../../components/shared/CustomDropdown'
import Pageloader from '../../components/shared/Pageloader'

const HospitalLoginMaster = () => {
  const update = useRef('EDIT')
  const facilityID = useRef('-1')
  const [options, setOptions] = useState([])
  const [selected, setSelected] = useState(null)
  const [facilities, setFacilities] = useState([])
  const [facility, setFacility] = useState(null)
  const [isPageLoading, setIsPageLoading] = useState(false)

  const onSelect = (e) => {
    const newValue = e.target.value
    setSelected(newValue)
  }

  const updateFacility = async (type, e) => {
    facilityID.current = e.ID
    update.current = type
    if (type === 'DELETE') {
      let a = await callFn('DELETE', { id: e.ID, name: e.Name })
      await getData()
    } else if (type === 'EDIT') {
      let selectedFacility = facilities.find((obj) => obj.label === e.Name)
      setFacility(selectedFacility)
      setApplicationURL(e.link)
      setLoginID(e.username)
      setpasswordID(e.password)
      setSelected(e.ApplicationType ? e.ApplicationType : options[0])
      setModalVisible(true)
    }
  }

  const buttonList = [
    { Name: 'Edit', FunctionName: updateFacility },
    { Name: 'Delete', FunctionName: updateFacility },
  ]
  const [diagnosisData, setDiagnosisData] = useState('')
  const [modalVisible, setModalVisible] = useState(false)
  const [applicationURL, setApplicationURL] = useState('')
  const [loginID, setLoginID] = useState('')
  const [passwordID, setpasswordID] = useState('')

  const handleonClick = (e) => {
    update.current = 'INSERT'
    setFacility(null)
    setApplicationURL('')
    setLoginID('')
    setpasswordID('')
    setModalVisible(true)
  }

  const saveFacility = async () => {
    setModalVisible(false)

    let name = facility ? facility.label : ''
    let link = applicationURL

    let a = await callFn(update.current, { id: facilityID.current, name, link, loginID, passwordID, selected })
    await getData()
  }

  const callFn = async (type, obj) => {
    let c = await FacilityLoginFn(type, obj.id, obj.name, obj.link, loginID, passwordID, selected)
    return c
  }

  const getData = async () => {
    setIsPageLoading(true)
    try {
      let facilityDetails = await FacilityCRUD('SELECT', {})
      let allFacilities = JSON.parse(facilityDetails.d)
      let facilities = []
      allFacilities?.Data.map((obj) => {
        facilities.push({ value: obj.ID, label: obj.Name })
      })
      setFacilities(facilities)

      let a = await callFn('SELECTALL', { id: '', name: '', link: '' })
      let c = await ApplicationTypeFn('SELECT')
      let allApplications = JSON.parse(c.d)
      let applications = []
      try {
        allApplications.Data.map((obj) => {
          applications.push(obj.name)
        })
      } catch (e) {
        console.error(e)
      }
      setOptions(applications)
      setSelected(applications ? applications[0] : '')

      let data = JSON.parse(a.d)
      setDiagnosisData(a.d)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const onFacilityChange = (selectedOption) => {
    setFacility(selectedOption)
  }

  const [theme, setTheme] = useState(() => localStorage.getItem('provio_theme') || 'dark')

  useEffect(() => {
    getData()
    const handleThemeChange = () => {
      setTheme(localStorage.getItem('provio_theme') || 'dark')
    }
    window.addEventListener('provio-theme-change', handleThemeChange)
    return () => {
      window.removeEventListener('provio-theme-change', handleThemeChange)
    }
  }, [])

  return (
    <div className="position-relative patient-theme-page" data-theme={theme}>
      <div className={`patient-page-wrapper page-wrapper patient-theme-shell ${theme === 'dark' ? 'dashboard-dark-theme' : ''}`}>
        <Pageloader isLoading={isPageLoading} />
        <CCard className="m-2">
          <CCardBody>
            <CButton 
              className="m-2" 
              onClick={handleonClick}
              style={{
                backgroundColor: 'var(--ui-color-primary, #2b7cd3)',
                borderColor: 'var(--ui-color-primary, #2b7cd3)',
                color: 'white',
              }}
            >
              + Add New Login
            </CButton>
          </CCardBody>
        </CCard>

        <CustomAgGrid className="hospital-login-theme__grid" rowClickedFn={updateFacility} callFrom="Facility" options={diagnosisData} btnList={buttonList} />

        <CModal 
          size="md" 
          backdrop={'static'} 
          visible={modalVisible} 
          onClose={() => setModalVisible(false)}
          className="dashboard-dark-modal patient-theme-modal"
          data-theme={theme}
        >
          <CModalHeader onClose={() => setModalVisible(false)}>
            <CModalTitle>Add New Login</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div className="mb-3">
              <CFormLabel>Name</CFormLabel>
              <Select 
                className="basic-single-select"
                classNamePrefix="select"
                options={facilities} 
                value={facility} 
                onChange={onFacilityChange} 
              />
            </div>
            <div className="mb-3">
              <CFormLabel>Link</CFormLabel>
              <CFormInput value={applicationURL} onChange={(e) => setApplicationURL(e.target.value)} />
            </div>
            <div className="mb-3">
              <CFormLabel>UserName</CFormLabel>
              <CFormInput value={loginID} onChange={(e) => setLoginID(e.target.value)} />
            </div>
            <div className="mb-3">
              <CFormLabel>Password</CFormLabel>
              <CFormInput value={passwordID} onChange={(e) => setpasswordID(e.target.value)} />
            </div>
            <div className="mb-3">
              <CFormLabel>Application Type</CFormLabel>
              <CustomDropdown options={options} onSelect={onSelect} selected={selected} />
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={() => setModalVisible(false)}>
              Close
            </CButton>
            <CButton 
              color="primary" 
              onClick={() => saveFacility()}
              style={{
                backgroundColor: 'var(--ui-color-primary, #2b7cd3)',
                borderColor: 'var(--ui-color-primary, #2b7cd3)',
                color: 'white',
              }}
            >
              Save Changes
            </CButton>
          </CModalFooter>
        </CModal>
      </div>
    </div>
  )
}

export default HospitalLoginMaster
